export default function Checkbox({ id, checked, onChange, radio, name, label }) {
   const identifier = id ?? `checkbox-${Math.random()}`
   return (
      <div className="flex items-center ">
         <input id={identifier} checked={checked} onChange={onChange} type={radio ? 'radio' : 'checkbox'} name={name} className={`${radio ? 'rounded-full' : 'rounded'} border-gray-300 text-yellow-600 p-2`} />
         {label && <label htmlFor={identifier} className="pl-4 select-none cursor-pointer	text-gray-600">{label}</label>}
      </div>
   )
}